import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { TEAM_FEATURE_GROUP } from './group';

export const TEAM_FEATURES = {
  CREATE: {
    guid: 'dea86780-cff4-4445-b969-4aae61ac0000',
    name: 'team:create',
    description: 'Invite new users to the organization',
    action: 'create',
    product: 'account',
    parentGuid: TEAM_FEATURE_GROUP.guid,
  },
  READ: {
    guid: 'dea86780-cff4-4445-b969-4aae61ac0001',
    name: 'team:read',
    description: 'View organization users and their details',
    action: 'read',
    product: 'account',
    parentGuid: TEAM_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'dea86780-cff4-4445-b969-4aae61ac0002',
    name: 'team:update',
    description: 'Edit organization user details and roles',
    action: 'update',
    product: 'account',
    parentGuid: TEAM_FEATURE_GROUP.guid,
  },
  ARCHIVE: {
    guid: 'dea86780-cff4-4445-b969-4aae61ac0003',
    name: 'team:archive',
    description: 'Archive and restore organization users',
    action: 'update',
    product: 'account',
    parentGuid: TEAM_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { TEAM_FEATURE_GROUP } from './group';

export const TEAM_MODULE: FeatureModule = {
  product: 'account',
  groups: [TEAM_FEATURE_GROUP],
  features: featureList(TEAM_FEATURES),
};
